import { Box, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
// import { tokens } from "../../../../theme";
// import { tokens } from "../../../../../../theme";

// import Subheading from "../../../../../../components/theme/text/Subheading";

import { useTranslation } from "react-i18next";
import { useInView } from "react-intersection-observer";
import NotificationsContent from "../../../../components/global/Notifications/Notifications";
import Subheading from "../../../../components/theme/text/Subheading";
import { useGetNotificationHistoryQuery } from "../../../../newapi/pwa/pwaSlice";
import { tokens } from "../../../../theme";

const GenericReturnBuilderScreenWrapper = (props) => {
    const { t } = useTranslation();
    const apiRef = props.apiRef;
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const LIMIT = 20;

    const [page, setPage] = useState(1);
    const [mergedData, setMergedData] = useState({ notifications: [] });
    
    // const {data,isLoading, isFetching,error} = useGetNotificationHistoryQuery("",{pollingInterval:1000*60*3});
    const { data, isLoading, isFetching, error } = useGetNotificationHistoryQuery(
        { 
            page, 
            limit: LIMIT 
        },
        {
            skip: false,
        }
    );
    useEffect(() => {
        if (data?.data?.notifications?.length) {
            setMergedData(prev => ({
                ...prev,
                notifications: [...prev.notifications, ...data.data.notifications],
            }));
        }
    }, [data]);

    const { ref, inView } = useInView({
        threshold: 1.0,
    });

    useEffect(() => {
        if (inView) {
            
            // 
        }
    }, [inView]);

    useEffect(() => {
        if (inView && !isFetching && data?.data?.notifications?.length > 0) {
            setPage(prev => prev + 1);
        }
    }, [inView,isFetching]);

    // console.log(data);
    useEffect(() => {
        props.replaceView({
            ...props.config,
        });

        return () => {
            // console.log("unmounting warehouse");
        }
    },[]);

    

    return (
        <Box
            sx={{
                p:3,
                p:1,
                pb:0,
                borderTopLeftRadius:"16px",
                borderTopRightRadius:"16px",
                height:1,
                // height: 'calc(100vh - 182px)',
                // overflow: "hidden",
                "@media screen and (max-width: 47.9375em)" : {
                    paddingTop:0,
                    paddingX:0,
                },
            }}
        >
            <Box
                sx={{
                    // clipPath: 'inset(0 round 32px 32px 0 0)', // Match your border radius
                    height: '100%',
                    // overflow: "hidden",
                }}
            >
                <Box
                    sx={{
                        overflow: "hidden", 
                        display:"flex",
                        // background:theme.palette.mode === "dark" ? colors.grey[300]: colors.bg['tertiary'],
                        height:1,
                        borderTopLeftRadius:24,
                        borderTopRightRadius:24,
                        // boxShadow:"0 0 19px rgba(49,65,95,.25)",
                        // border: `1px solid ${theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[200]}`,
                        borderBottom:"none",
                        "@media screen and (max-width: 47.9375em) " : {
                            flexDirection:"column",
                            boxShadow:"none",
                            border:"none",
                            borderRadius:0,
                            overflow:"auto",
                            // display:"block",
                        }
                    }}
                >
                    {/* Editting stuff */}
                    <Box
                        sx={{
                            overflow:"hidden",
                            background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                            // width:350,
                            width:1,
                            display:"flex",
                            flexDirection:"column",
                            // boxShadow: "0 0 19px rgba(49,65,95,.25)",
                            pt:3,
                            "@media screen and (max-width: 47.9375em) " : {
                                mt:3,
                                flex:1,
                                width:"unset",
                                borderTopLeftRadius:24,
                                borderTopRightRadius:24,
                                // gap:1,
                            }
                        }}
                    >
                        <Box
                            sx={{
                                pl:1.5,
                                display:"flex",
                                justifyContent:"center",
                            }}
                        >
                            <Subheading
                                sx={{
                                    width:600,

                                }}
                            >
                                {t("notifications")}
                            </Subheading>
                        </Box>
                        <Box
                            sx={{
                                width:1,
                                height:1,
                                overflow:"auto",
                                mt:2,
                                display:"flex",
                                flexDirection:"column",
                                alignItems:"center",
                                "@media screen and (max-width: 47.9375em) " : {
                                    height:"unset",
                                    overflow:"hidden",
                                    pb:10,
                                }
                            }}
                        >
                            {mergedData?.notifications?.length > 0 && (
                                <NotificationsContent 
                                    data={mergedData}
                                    compSx={{ width: 600 }}
                                />
                            )}

                            <div ref={ref} style={{ height: "1px" }} >

                                {isFetching && <p>Loading more...</p>}
                            </div>
                        </Box>
                        
                    </Box>
                    {/* <Box
                        sx={{
                            flex: 1,
                            overflow: 'hidden',
                            minHeight: "1px",
                            display: 'flex', 
                            flexDirection: 'column',
                            "@media screen and (max-width: 47.9375em)" : {
                                flex:2,
                            },
                        }}
                    >
                        <Box
                            className={cx('',{
                                'modal': props.open
                            })}
                            sx={{
                                position:'relative',
                                p: 3,
                                width: 1,
                                overflow: "auto",
                                flex: 1,
                                display:"flex",
                                justifyContent:'center',
                                "&.modal": {
                                    p:0,
                                },

                                "@media screen and (max-width: 47.9375em) " : {
                                    p:0,
                                    px:3,
                                    overflow: "hidden",
                                }
                            }}
                        >
                            
                            

                        


                             <Box 
                            
                                className={cx('', {
                                    
                                })}
                                sx={{
                                    transition:"300ms",
                                    borderRadius:4,
                                    height:3000,
                                    
                                }}
                            >
                               

                            </Box> 

                        </Box>
                    </Box> */}
                  
                </Box>
            </Box>
                
        </Box>
    )
};

export default GenericReturnBuilderScreenWrapper;